import {
  GetResourcesParams,
  GetResourcesSearchParams,
  GetResourcesPaginatedParams,
  GetResourcesPaginatedParamsExtended,
} from '../../services/learning-api';

interface LearningSkillCategoryParams {
  roleDepartmentId?: string;
}

interface UserParams {
  userType?: string;
  department?: string;
  roleDepartmentId?: string;
}

export const QUERY_KEYS = {
  learning: {
    roleProfiles: (params: { userType?: string }) => ['learning-api:role:profiles', params],
    manageRoleProfiles: (params: { userType?: string }) => [
      'learning-api:manage:role:profiles',
      params,
    ],
    roleDepartmentId: () => ['learning-api:role:roleDepartmentId'],
    userProfiles: () => ['learning-api:user:profiles'],
    userSettings: () => ['learning-api:user:settings'],
    quizSession: (params?: UserParams) => ['learning-api:quiz-session', params],
    postSkillCategoryAssessment: (params: any) => [
      'learning-api:quiz-session:post-skill-category-assessment',
      params,
    ],
    history: () => ['learning-api:quiz-session:history'],
    skillCategory: (params: LearningSkillCategoryParams) => [`learning-api:skill-category`, params],
    getSkillGroup: (params: string[]) => [`learning-api:skill-group`, params],
    getResources: (params?: GetResourcesParams) => ['learning-api:resource', params],
    getResourcesPaginated: (params: GetResourcesPaginatedParams) => [
      'learning-api:resource:paginated',
      params,
    ],
    resourcesPaginated: () => ['learning-api:resource:paginated'],
    bookmarkedResources: () => ['learning-api:resource:bookmarked'],
    getResourcesForManager: (params?: GetResourcesPaginatedParamsExtended) => [
      'learning-api:resource:manager',
      params,
    ],
    getResourcesSearch: (params: GetResourcesSearchParams) => [
      'learning-api:resource-search',
      params,
    ],
    resourceBookmarks: () => ['learning-api:resource:bookmarks'],
    getResourceBookmarks: () => ['learning-api:resource:bookmarks'],
    inProgressResources: () => ['learning-api:resource:in-progress'],
    resourceFacets: () => ['learning-api:resource:facets'],
    resourceRecommendations: () => ['learning-api:resource:recommendations'],
    content: {
      getFaq: () => ['learning-api:content:faq'],
    },
    banner: () => ['learning-api:banner'],
    infoBanner: () => ['learning-api:info-banner'],
    putUserResourceInteraction: () => ['learning-api:resource:user-interaction'],
    specialism: () => ['learning-api:specialism'],
    manageSpecialism: () => ['learning-api:manage:specialisms'],
    getHotTopics: () => ['learning-api:specialism:get-hot-topics'],
    roleDepartments: () => ['learning-api:role:departments'],
  },
} as const;
